<template>
	<form-remote-select v-bind="props" @update:modelValue="value => emit('update:modelValue', value)"
						action="/v1/sports/options"
						text-prop="title"
						group-prop="fetch_reason"
						:value-prop="props.valueProp"
						as-guest/>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
	// The property name of the results where to retrieve the option's value from
	valueProp?: string;
}>(), {
	valueProp: '_key'
});
const emit = defineEmits(['update:modelValue']);
</script>